import { render, staticRenderFns } from "./TableWithFilter.vue?vue&type=template&id=48dd7a82&scoped=true"
import script from "./TableWithFilter.vue?vue&type=script&lang=js"
export * from "./TableWithFilter.vue?vue&type=script&lang=js"
import style0 from "./TableWithFilter.vue?vue&type=style&index=0&id=48dd7a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd7a82",
  null
  
)

export default component.exports